"use strict";
/**
 * @module Topics
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a NOTIFY_SUBSCRIPTION request.
 */
var TopicSpecificationInfo = /** @class */ (function () {
    /**
     * Create a new TopicSpecificationInfo instance
     *
     * @param id            the topic ID
     * @param path          the topic path
     * @param specification the topic specification
     */
    function TopicSpecificationInfo(id, path, specification) {
        this.id = id;
        this.path = path;
        this.specification = specification;
    }
    return TopicSpecificationInfo;
}());
exports.TopicSpecificationInfo = TopicSpecificationInfo;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/topics/details/topic-specification-info.js
// module id = 1474
// module chunks = 1